import React, { useEffect, useRef, useState } from 'react';
import ColorPicker from '../../../../../general-ui/color-picker/color';

interface Props {
	color: [string, number];
	title: string;
	onChange: any;
}
export default function ColorEditor(props: Props): JSX.Element {
	const {
		color,
		title,
		onChange
	} = props;
	const [hex, opacity] = color;

	const [pickedColor, setPickedColor] = useState(hex);
	const [pickedOpacity, setPickedOpacity] = useState(Math.ceil(opacity * 100));
	const [pickerOpen, setPickerOpen] = useState(false);

	const self = useRef<HTMLDivElement>(null);

	useEffect(() => {
		onChange(pickedColor, pickedOpacity / 100);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pickedColor, pickedOpacity]);

	useEffect(() => {
		if (pickerOpen) {
			window.addEventListener('click', handleClose);
		}
		return () => window.removeEventListener('click', handleClose);
	}, [pickerOpen]);

	const handleClose = (e: any) => {
		const path = e.path || e.composedPath();
		for (const item of path) {
			if (self.current === item) { return; }
		}
		setPickerOpen(false);
	};

	function closeColorPicker() {
		setPickerOpen(false);
	}

	function handleColorChange(e: any) {
		setPickedColor(e.hex);
	}

	function handleSetOpacity(e: React.ChangeEvent<HTMLInputElement>) {
		setPickedOpacity(e.target.valueAsNumber);
	}

	function handleSetColor(e: React.ChangeEvent<HTMLInputElement>) {
		setPickedColor("#" + e.target.value);
	}

	function handleClick() {
		setPickerOpen(prev => !prev);
	}

	return (
		<div className="color-editor">
			<label>{title}</label>
			<div className="color-input">
				<div className="color-input-left" ref={self}>
					<div className="color-bubble" onClick={handleClick} style={{ backgroundColor: `${hex}` }} />
					<span className="hex-readout"># <input type="text" value={pickedColor.replace("#", "").toUpperCase()} onChange={handleSetColor} /></span>
					<ColorPicker
						open={pickerOpen}
						value={pickedColor}
						color={pickedColor}
						label={title}
						close={closeColorPicker}
						onChangeComplete={handleColorChange}
					/>
				</div>
				<div className="color-input-right"><input type="number" min={0} max={100} step={1} value={pickedOpacity} onChange={handleSetOpacity} />%</div>
			</div>
		</div>
	);
}